import { render, staticRenderFns } from "./SuppliersNavBar.vue?vue&type=template&id=22414ce0"
import script from "./SuppliersNavBar.vue?vue&type=script&lang=js"
export * from "./SuppliersNavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports